import * as React from "react";
import "./index.css";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import ShareButtonBlack from "../../common/ShareButton/ShareBlack";
import MediaTab from "./MediaTab";
import OverviewTab from "./OverviewTab";
import StaysTab from "./StaysTabs";
import StopsTab from "./StopsTabs";
import { useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DetailPage from "../../DetailPage/Index";
import { fetchCurrentState } from "../../../redux/features/customerViewSlice";
import ReactCountryFlag from "react-country-flag";

import {
  capitalizeFirstLetter,
  dateRangeFormat,
  guestInfo,
  handleSession,
} from "../../../util";
import { Navigate, Outlet, redirect, useNavigate } from "react-router";
import CustomerView from "../index";
import { isEmpty } from "lodash";
import { useEffect } from "react";
import TextTruncate from "react-text-truncate";
import { useMemo } from "react";
import { useCallback } from "react";
import whatsappIcon from "../../../assets/images/icons/whatsapp-icon.svg";
import { useState } from "react";
import useGAEventTracker from "../../common/customHooks/useGAEventTracker";
import {
  analyticsEvent,
  eventName,
} from "../../common/Analytics/AnalyticsEvent";
import { scrollTop, val } from "dom7";
import { TabScrollButton } from "@mui/material";
import { useRef } from "react";

const activeTabs = {
  1: "Media",
  2: "Overview",
  3: "Stays",
  4: "Stops",
};

const activeTabsShareName = {
  1: eventName.Media_share_success,
  2: eventName.Overview_share_success,
  3: eventName.Stays_share_success,
  4: eventName.Stops_share_success,
};
const activeTabsScrollEnd = {
  1: eventName.Media_scrolled_till_end_of_page,
  2: eventName.Overview_scrolled_till_end_of_page,
  3: eventName.Stays_scrolled_till_end_of_page,
  4: eventName.Stops_scrolled_till_end_of_page,
};

function ViewTrip(props) {
  const navigate = useNavigate();
  const targetRef = useRef();
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case "1":
        analyticsEvent.clickEvent("Media", eventName.Media_tab_selected);
        break;
      case "2":
        analyticsEvent.clickEvent("Overview", eventName.Overview_tab_selected);
        break;
      case "3":
        analyticsEvent.clickEvent("Stays", eventName.Stays_tab_selected);
        break;
      case "4":
        analyticsEvent.clickEvent("Stops", eventName.Stops_tab_selected);
        break;
      default:
        break;
    }
  };
  // sticky navbar
  const [stickyClass, setStickyClass] = useState("");

  // const handleScroll = (e) => {
  //   const bottom =
  //     e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight
  //   console.log(bottom)
  //   if (bottom) {
  //   }
  // }
  let category = activeTabs[value];
  let action = activeTabsScrollEnd[value];
  useEffect(() => {
    window.addEventListener("scroll", stickNavbar);
    return () => window.removeEventListener("scroll", stickNavbar);
  }, [value]);
  // window.onscroll = function (ev) {
  //   if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
  //     // you're at the bottom of the page
  //     console.log('>>>>>>bottom reached.....')
  //   }
  // }

  const stickNavbar = (e) => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;

      // console.log(e.currentTarget)
      // console.log(window.scrollY + window.innerHeight)
      // console.log(document.body)
      // console.log(e.currentTarget.scrollY)

      analyticsEvent.endScrollEvent(targetRef, category, action);

      // let newScrollHeight = ~~targetRef.current.getBoundingClientRect().bottom
      // console.log(targetRef.current.getBoundingClientRect().bottom)
      // console.log(window.window.innerHeight)

      windowHeight > 50 ? setStickyClass("sticky-nav") : setStickyClass("");
    }
  };

  // Sticky navbar

  // const tripStateData = useSelector(fetchCurrentState)

  // detailPageModal state handler

  // --------------------//

  const temp = 1;

  if (isEmpty(props.tripStateData)) {
    // console.log(tripStateData)
    window.location.href = "/error";
  }

  console.log(">>>>>:: ViewTrip Rendered");

  useEffect(() => {
    console.log("viewtrip use Effect >>>>:: rendering");
  }, [temp]);

  return (
    <div style={{ position: "relative" }}>
      <div className="header-container">
        <div style={{ width: "90%" }}>
          {/* <TextTruncate
            line={1}
            element="p"
            truncateText="…"
            text={props.tripStateData.display_name}
            containerClassName="headline1"
            style={{
              // color: 'white',
              lineHeight: '22.5px',
            }}
          /> */}
          <p className="headline1 truncated">
            {props.tripStateData.display_name}
          </p>
        </div>
        <div
          onClick={() => {
            switch (value) {
              case "1":
                analyticsEvent.clickEvent(
                  activeTabs[value],
                  eventName.Media_share_opened
                );
                break;
              case "2":
                analyticsEvent.clickEvent(
                  activeTabs[value],
                  eventName.Overview_share_opened
                );
                break;
              case "3":
                analyticsEvent.clickEvent(
                  activeTabs[value],
                  eventName.Stays_share_opened
                );
                break;
              case "4":
                analyticsEvent.clickEvent(
                  activeTabs[value],
                  eventName.Stops_share_opened
                );
                break;
              default:
                break;
            }
          }}
        >
          <ShareButtonBlack
            eventName={activeTabsShareName[value]}
            category={activeTabs[value]}
          />
        </div>
      </div>
      {/* {overviewDetails && <p className="body3">Bali, Indonesia</p>} */}
      <Box sx={{ width: "100%", typography: "body1", height: "100vh" }}>
        <TabContext value={value}>
          <Box
            sx={{ background: "white", zIndex: "100" }}
            className={`${stickyClass}`}
          >
            <TabList
              onChange={handleChange}
              aria-label="Trip Tabs section"
              variant="fullWidth"
              TabIndicatorProps={{
                style: { background: "var(--primaryTeal)" },
              }}
              sx={{ minHeight: "48px" }}
            >
              <Tab
                label="Media"
                value="1"
                className="tabs-label headline2"
                sx={{ padding: "0px", margin: "0px" }}
              />
              <Tab
                label="Overview"
                value="2"
                className="tabs-label headline2"
                sx={{ padding: "0px", margin: "0px" }}
              />
              <Tab
                label="Stays"
                value="3"
                className="tabs-label headline2"
                sx={{ padding: "0px", margin: "0px" }}
              />
              <Tab
                label="Stops"
                value="4"
                className="tabs-label headline2"
                sx={{ padding: "0px", margin: "0px" }}
              />
            </TabList>
          </Box>
          <div className="tab-content" ref={targetRef}>
            <TabPanel
              value="1"
              sx={{
                paddingTop: "0px",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
            >
              <MediaTab
                tripStateData={props.tripStateData}
                handleDetailPageOpen={props.handleDetailPageOpen}
                detailPageState={props.detailPageState}
                activeTab={value}
              />
            </TabPanel>
            <TabPanel
              value="2"
              sx={{
                paddingTop: "0px",
                paddingRight: "0px",
                paddingBottom: "24px",
                paddingLeft: "0px",
              }}
            >
              <OverviewTab
                tripStateData={props.tripStateData}
                handleDetailPageOpen={props.handleDetailPageOpen}
                activeTab={value}
              />
            </TabPanel>
            <TabPanel
              value="3"
              style={{
                paddingTop: "24px",
                paddingLeft: "20px",
                paddingRight: "20px",
                height: "100%",
              }}
            >
              <StaysTab
                tripStateData={props.tripStateData}
                handleDetailPageOpen={props.handleDetailPageOpen}
                activeTab={value}
              />
            </TabPanel>
            <TabPanel
              value="4"
              style={{
                paddingTop: "24px",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
            >
              <StopsTab
                tripStateData={props.tripStateData}
                handleDetailPageOpen={props.handleDetailPageOpen}
                activeTab={value}
              />
            </TabPanel>
          </div>
        </TabContext>
      </Box>
      <div
        className="float"
        onClick={() => {
          switch (value) {
            case "1":
              analyticsEvent.clickEvent(
                activeTabs[value],
                eventName.Media_chat_opened
              );
              break;
            case "2":
              analyticsEvent.clickEvent(
                activeTabs[value],
                eventName.Overview_chat_opened
              );
              break;
            case "3":
              analyticsEvent.clickEvent(
                activeTabs[value],
                eventName.Stays_chat_opened
              );
              break;
            case "4":
              analyticsEvent.clickEvent(
                activeTabs[value],
                eventName.Stops_chat_opened
              );
              break;
            default:
              break;
          }
        }}
      >
        <a
          href="https://api.whatsapp.com/send?phone=918448832373&text=Hey%20there%21%20%F0%9F%98%80%20I%20need%20help%20with%20booking%2Fwant%20to%20know%20more%20about%20ongoing%20offers.%0A"
          target="__blank"
        >
          <img src={whatsappIcon} alt="whatsapp-button"></img>
        </a>
      </div>
    </div>
  );
}

export default ViewTrip;
export const MemoViewTrip = React.memo(ViewTrip);
